var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#051D39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.444 8c0-.368.299-.667.667-.667h5.778a.667.667 0 110 1.334H5.11A.667.667 0 014.444 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.556a.667.667 0 01-.667-.667V5.11a.667.667 0 111.334 0v5.778a.667.667 0 01-.667.667z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.3,
    stroke: "#051D39",
    strokeWidth: 1.4
  }))));
}

export default SvgPlus;